import { WorkshopReview } from '../../models';
import { GET_REVIEWS } from '../constants/workshopReviewsList';

// eslint-disable-next-line import/prefer-default-export
export const getWorkshopReviews = (data) => {
  const convertedReviews = data.map((item) => {
    // eslint-disable-next-line camelcase
    const { id, is_author, name, rate, make, model, opinion, created_at, reported } = item;
    return new WorkshopReview(
      id,
      is_author,
      name,
      rate,
      opinion,
      make,
      model,
      created_at,
      reported,
    );
  });

  return {
    type: GET_REVIEWS,
    payload: convertedReviews,
  };
};
